/* IronGrind – motion layer (scroll reveals, scroll-linked zoom/parallax, word light-up, hero parallax).
   Settings live in the "IGA motion" section (Footer group). No app, no library.
   Turns itself off for visitors who ask their device for reduced motion, and inside the theme editor. */
(function () {
  var C = window.IGA_MOTION || {};
  if (!C.enabled) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  var root = document.documentElement;
  root.classList.add('iga-m-on');
  root.style.setProperty('--iga-m-dist', (C.distance || 32) + 'px');
  root.style.setProperty('--iga-m-dur', (C.duration || 900) + 'ms');

  var vh = window.innerHeight;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function inView(el) { var r = el.getBoundingClientRect(); return r.top < vh * 0.92 && r.bottom > 0; }

  /* 1. Reveal on scroll ------------------------------------------------------ */
  var GROUPS = [
    '.iga-doors__head', '.iga-tiles__head', '.yv-new-arrival-slider-header', '.iga-why__eyebrow', '.iga-why__title',
    '.iga-story__eyebrow', '.iga-story__body', '.iga-story__btn', '.iga-set__head',
    'main .shopify-section .heading-title', 'main .shopify-section .section-heading',
    '.iga-door', '.iga-tile', '.iga-why__card', '.iga-story__value', '.yv-product-card',
    '.yv-new-arriavl-imgbox', '.yv-social-media-item', '.yv-icon-text-box', '.rich-text-wrapper .button'
  ];
  var revealEls = [];
  if (C.reveal) {
    var seen = new Set();
    GROUPS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (seen.has(el) || el.closest('.iga-hero') || el.closest('header') || el.closest('footer')) return;
        /* skip anything inside an element we already reveal, so nothing double-animates */
        for (var p = el.parentElement; p; p = p.parentElement) { if (seen.has(p)) return; }
        seen.add(el); revealEls.push(el);
      });
    });
    var stagger = new Map();
    revealEls.forEach(function (el) {
      if (inView(el)) return; /* already on screen at load: leave it alone, no flash */
      var parent = el.parentElement;
      var i = stagger.get(parent) || 0;
      stagger.set(parent, i + 1);
      el.style.setProperty('--iga-m-delay', Math.min(i, 6) * 70 + 'ms');
      el.classList.add('iga-m-reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.iga-m-reveal').forEach(function (el) { io.observe(el); });
  }

  /* 2. Scroll-linked effects (only while on screen) --------------------------- */
  var linked = [];
  function addLinked(el, type) { el.classList.add('iga-m-' + type); linked.push({ el: el, type: type, on: false }); }

  if (C.zoom) {
    document.querySelectorAll('.iga-door, .iga-story__media, .yv-new-arriavl-imgbox').forEach(function (el) { addLinked(el, 'zoom'); });
  }
  if (C.words) {
    document.querySelectorAll('.iga-why__intro, .iga-story__title').forEach(function (el) {
      if (el.querySelector('.iga-w')) return;
      var words = el.textContent.trim().split(/\s+/);
      el.setAttribute('aria-label', el.textContent.trim());
      el.innerHTML = words.map(function (w) { return '<span class="iga-w" aria-hidden="true">' + w.replace(/</g, '&lt;') + '</span>'; }).join(' ');
      addLinked(el, 'words');
    });
  }
  var hero = C.hero ? document.querySelector('.iga-hero') : null;
  if (hero) addLinked(hero, 'hero');

  var lio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      linked.forEach(function (l) { if (l.el === e.target) l.on = e.isIntersecting; });
    });
    tick();
  }, { rootMargin: '10% 0px 10% 0px' });
  linked.forEach(function (l) { lio.observe(l.el); });

  var ticking = false;
  function tick() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      for (var i = 0; i < linked.length; i++) {
        var l = linked[i]; if (!l.on) continue;
        var r = l.el.getBoundingClientRect();
        if (l.type === 'zoom') {
          /* 0 when the top edge enters the bottom of the screen, 1 when it reaches 35% from the top */
          l.el.style.setProperty('--z', clamp((vh - r.top) / (vh * 0.65), 0, 1).toFixed(3));
        } else if (l.type === 'words') {
          var p = clamp((vh * 0.85 - r.top) / (vh * 0.5 + r.height), 0, 1);
          var ws = l.el.__w || (l.el.__w = l.el.querySelectorAll('.iga-w'));
          var lit = Math.round(p * ws.length * 1.15);
          for (var k = 0; k < ws.length; k++) ws[k].classList.toggle('is-lit', k < lit);
        } else if (l.type === 'hero') {
          l.el.style.setProperty('--p', clamp(-r.top / Math.max(r.height, 1), 0, 1).toFixed(3));
        }
      }
    });
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', function () { vh = window.innerHeight; tick(); });
  tick();
})();
